import { Grid } from '@mui/material';
import React, { ChangeEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { WorkItemType } from '../../../api/projects-api';
import { addAttachmentTC_, addCommentTC_, setMyCommentTextAC } from './comments-reducer';
import { ContentEditable } from './ContentEditableDiv';

type CommentInputPropsType = {
  projectName: string
  projectId: number
  item: WorkItemType
  myCommetText: string
}

export const CommentInput = React.memo((props: CommentInputPropsType) => {
  const dispatch = useDispatch()
  const areaPath = props.item?.fields?.['System.AreaPath'] as string

  const setMyCommentText = useCallback((text: string) => {
    dispatch(setMyCommentTextAC({ projectName: props.projectName, taskId: props.item.id, text }))
  }, [dispatch])

  const addFileToComment = useCallback((event: ChangeEvent<HTMLInputElement>) => {

    let file: any
    if (event.target.files) {
      file = event.target.files[0]
      console.log(file)
      const imgSrc = URL.createObjectURL(file)
      let formData = new FormData()
      formData.append("formdata", file)
      dispatch(addAttachmentTC_({ imgSrc, projectId: props.projectId, projectName: props.projectName, areaPath: areaPath, fileName: file.name, formData, taskId: props.item.id }))
    }
  }, [dispatch, props.projectName])

  const sendComment = () => {
    dispatch(addCommentTC_({ projectName: props.projectName, projectId: props.projectId, taskId: props.item.id }))
  }

  return <Grid container className='comment'>
    <ContentEditable myCommetText={props.myCommetText} addFileToComment={addFileToComment} sendComment={sendComment}
      setHtml={setMyCommentText} />
  </Grid>
})
